export default "__VITE_ASSET__DaYNXuTq__"